export default "__VITE_ASSET__CU8DSmW2__"